import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  query($order: [OrdersFindOrder!],$where: OrdersFindFilter) {\n    exportOrdersStatList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query($order: [OrdersFindOrder!],$where: OrdersFindFilter) {\n    exportOrdersList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  query {\n    findAllUsedPeriodSettings\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query($order: [OrdersFindOrder!], $paging: PagingQuery, $where: OrdersFindFilter) {\n    findOrders(\n      order: $order,\n      paging: $paging,\n      where: $where\n    ) {\n      orders {\n        period\n        phone\n        realname\n        address {\n          className\n          isDefault\n          schoolId\n          updatedAt\n          year\n          school {\n            name\n            area {\n              mergerName\n            }\n          }\n        }\n        dealer {\n          id\n          realname\n          storePhone\n          storePhone\n          user {\n            phone\n          }\n        }\n        refund {\n          auditStatus\n          refundWay\n        }\n        areaId\n        buyerMessage\n        className\n        createdAt\n        dealerId\n        errCode\n        errCodeDes\n        id\n        items {\n          id\n          title\n          count\n          price\n          author\n          thumb\n        }\n        memberId\n        member {\n          id\n          nickname\n        }\n        memberUniqueId\n        orderNumber\n        transactionNumber\n        schoolId\n        status\n        timeEnd\n        totalPrice\n        tradeType\n        updatedAt\n        year\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n      totalAmount\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query($orderId: Int!) {\n    findOrder(\n      orderId: $orderId,\n    ) {\n      addressId\n      areaId\n      bankType\n      buyerMessage\n      teacherName\n      teacherPhone\n      className\n      createdAt\n      dealerId\n      errCode\n      errCodeDes\n      id\n      period\n      grade\n      mailingAddress\n      realname\n      phone\n      memberId\n      memberUniqueId\n      orderNumber\n      schoolId\n      status\n      timeEnd\n      totalPrice\n      tradeType\n      updatedAt\n      year\n      transactionNumber\n      school {\n        name\n      }\n      dealer {\n        id\n        realname\n        storePhone\n        storePhone\n        user {\n          phone\n        }\n      }\n      items {\n        id\n        title\n        count\n        price\n        author\n        thumb\n      }\n      member {\n        id\n        nickname\n      }\n      profitSharing {\n        bankType\n        id\n        profitSharingNumber\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($password: String!, $username: String!) {\n    signIn(\n      password: $password,\n      username: $username\n    ) {\n      id\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($nameFilter: String) {\n    getAllUsers(\n      nameFilter: $nameFilter,\n    ) {\n      id\n      username\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var getAllUsers = gql(_templateObject());
export var signIn = gql(_templateObject2());
export var findOrder = gql(_templateObject3());
export var findOrders = gql(_templateObject4());
export var findAllPeriod = gql(_templateObject5());
export var exportOrdersList = gql(_templateObject6());
export var exportOrdersStatList = gql(_templateObject7());